const initialProductDataState = {
  products : false,

}

export const ProductReducer = (state = initialProductDataState, action = {}) => {

    switch (action.type) {
       
        case 'SET_PRODUCTS':    
          return {
            ...state,
            products: action.payload.products,
            columns: action.payload.columns
          }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ProductReducer.js